<script>

    import { toast } from 'bulma-toast'
    import { userStore, invoicesStore } from '../stores'

    import InvoicesService from '../$services/facturama.services'
    import DateMethods from '../$methods/date.methods'
    import NumeralMethods from '../$methods/numeral.methods'

    import ButtonModal from '../$components/button.modal.svelte'
    import Button from '../$components/button.svelte'
    import Table from '../$components/table.svelte'

    export let all = false

    let loading = false
    let element = null
    let query = { page: 0 }
    let metadata = {}

    getInvoices()

    async function getInvoices() {

        if(all)
            query.admin = true
        else
            query.userId = $userStore._id

        loading = true
        const resp = await InvoicesService.getInvoices(query)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        invoicesStore.set(resp.data.invoices)
        metadata = resp.data.metadata
    }

    async function getInvoiceDocument(invoice, type) {

        loading = true
        const blob = await InvoicesService.getInvoiceDocument(invoice.invoiceId, type)
        loading = false

        if(!blob)
            return toast({message: 'Error al descargar la factura', type: 'is-danger'})

        element.download = `${invoice.rfc}.${DateMethods.dateShort(invoice.created)}.${type}`
        element.href = window.URL.createObjectURL(blob)
        element.click()
    }

</script>

<a bind:this={element} href="/" style="display: none;">.</a>

<Table
    items={ $invoicesStore.length }
    total={ metadata.total }
    { loading }
    skeletonCols={7}
    bind:metadata
    bind:page={ query.page }
    on:change={ getInvoices }
>
    <div slot="header" class="header-filters">
        {#if !all}
            <div class="header-top">
                <ButtonModal modalId="invoice_create_free_modal" text="Agregar" icon="plus" />
            </div>
        {/if}
    </div>
    <thead slot="thead">
        <tr>
            <th>#</th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-dollar-sign"></i></span>
                    <span>Monto</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-user"></i></span>
                    <span>Nombre</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-id-card"></i></span>
                    <span>RFC</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-tag"></i></span>
                    <span>Tipo</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-calendar"></i></span>
                    <span>Fecha</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-ellipsis-v"></i></span>
                    <span>Acciones</span>
                </span>
            </th>
        </tr>
    </thead>
    <tbody slot="tbody">
        {#each $invoicesStore as invoice, index}
            <tr>
                <td><span>{ metadata?.items != null ? (metadata.items * (query.page ?? 0)) + (index + 1) : index + 1 }</span></td>
                <td>{ NumeralMethods.cash(invoice.amount) }</td>
                <td>{ invoice.name }</td>
                <td>{ invoice.rfc }</td>
                <td>{ invoice.paymentType }</td>
                <td>{ DateMethods.dateTimeLarge(invoice.created) }</td>
                <td>
                    <Button on:click={() => getInvoiceDocument(invoice, 'pdf')} text="PDF" icon="file-pdf" />
                    <Button on:click={() => getInvoiceDocument(invoice, 'xml')} text="XML" icon="file-code" />
                </td>
            </tr>
        {/each}
    </tbody>
</Table>
